
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/politica-de-cookies",
      function () {
        return require("private-next-pages/legal/politica-de-cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/politica-de-cookies"])
      });
    }
  